import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { BaseView } from "../Base/BaseView";
import { ImageTextCounterElement } from "../../Components/Elements/Texts/ImageTextCounterElement";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { PaylinesExtended } from "../../CustomComponents/PaylinesExtended";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { WinAnimatorExtendedFS } from "../../CustomComponents/WinAnimatorExtendedFS";
import { AppContext } from "../../../Common/AppContext";
import { BetManager } from "../../Managers/BetManager";
import { ModuleManager } from "../../Managers/ModuleManager";
import { GameData } from "../../Channels/Common/Datas/GameData";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { GroupTweens } from "../../CustomComponents/GroupTweens";
import Scale = Proton.Scale;
import { Scaling } from "../../Utils/Scaling";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends LayoutContainerElement {
    private _controller: FreespinsController;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private _machineStoppedDelay: FrameTimerEventEmitter;
    private _paylines: PaylinesExtended;
    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimatorExtendedFS;
    private _background: SwitchElement;
    private _groupTweensFs: SwitchElement;
    private _branchesFs: SwitchElement;
    private _tombFs: SwitchElement;

    private _multiplierDelay: FrameTimerEventEmitter;

    // private _fsMessageStart: HTMLElement;
    // private _fsMessageEnd: HTMLElement;
    // private _fsMessageEndNoWin: HTMLElement;
    private _bgParticles: SwitchElement;
    public static Multiplier: number = 0;
    public static FSCount: number = 0;
    public ReelFrame: SwitchElement;
    public ReelBg: SwitchElement;

    constructor() {
        super();
        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));
        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));
        this._machineStoppedDelay = CreateFrameTimer("machineStoppedDelay");
        this._machineStoppedDelay.on(FrameTimerEvents.Complete, this.machineStoppedDelayed.bind(this));
        this._multiplierDelay = CreateFrameTimer("multiplierDelay");
        this._multiplierDelay.on(FrameTimerEvents.Complete, this.setMultiplier.bind(this));
    }

    public create(node: Element): void {
        super.create(node);
        if (this.childs["Symbols"] != null) {
            this._symbols = this.childs["Symbols"];
            this.removeChild(this._symbols);
        }
        if (this.childs["Paylines"] != null) this._paylines = this.childs["Paylines"];
        if (this.childs["Machine"] != null) this._machine = this.childs["Machine"];
        if (this.childs["WinAnimator"] != null) this._winAnimator = this.childs["WinAnimator"];
        if (this.childs["Backgroundfs"] != null) this._background = this.childs["Backgroundfs"];
        if (this.childs["BGParticles"] != null) this._bgParticles = this.childs["BGParticles"];

        if (this.childs["Frame_fs"] != null) this.ReelFrame = this.childs["Frame_fs"];
        if (this.childs["ReelBg_fs"] != null) this.ReelBg = this.childs["ReelBg_fs"];
        if (this.childs["GroupTweensFs"] != null) this._groupTweensFs = this.childs["GroupTweensFs"];
        if (this.childs["Branches_fs"] != null) this._branchesFs = this.childs["Branches_fs"];
        // this._fsMessageStart = document.getElementById('fsMessageStart');
        // this._fsMessageEnd = document.getElementById('fsMessageEnd');
        // this._fsMessageEndNoWin = document.getElementById('fsMessageEndNoWin');
        //
        // //prevent first animation on page load
        // this._fsMessageStart.classList.add('_noAnim');
        // this._fsMessageEnd.classList.add('_noAnim');
        // this._fsMessageEndNoWin.classList.add('_noAnim');

        // set childs to GroupTweens object
        if (this._groupTweensFs) {
            let groupTweenElements: Object = this._groupTweensFs.getChildElements();
            if (groupTweenElements) {
                for (let key in groupTweenElements) {
                    if (groupTweenElements.hasOwnProperty(key)) {
                        if (groupTweenElements[key] instanceof GroupTweens) {
                            (<GroupTweens>groupTweenElements[key]).setChilds(this.childs);
                        }
                    }
                }
            }
        }
    }

    public initReceived(controller: FreespinsController): void {
        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            this._winAnimator,
                            this.childs["Teasing"],
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this.childs["NoWinContainer"],
                            this.childs["WinContainer"],
                            this,
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    public startReceived(): void {
        // if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        // }
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.reset(true);
    }

    public spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    public endReceived(): void {}

    public spin(): void {
        FreespinsView.FSCount = GameManager.freespinsResponse.freeSpins.remainingCount - 1;

        if (this.ReelFrame != null) {
            this.updateCounterValue(
                this.ReelFrame,
                (GameManager.freespinsResponse.freeSpins.remainingCount - 1).toString(),
            );
        }

        PlayList.loop("SND_FSLoop");
        // if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        // }
        if (this.ReelFrame.getCurrentCase() == "WIN") {
            this.ReelFrame.goToCase("TO_NORMAL");
            this.ReelBg.goToCase("TO_NORMAL");
        } else {
            this.ReelFrame.goToCase("NORMAL");
            this.ReelBg.goToCase("NORMAL");
        }
        this.resetReels();
        this._machine.spinStart(this._winAnimator.reset(true, true), true, this._winAnimator.currentSymbols);
    }

    public stop(): void {
        this._machine.spinStop(null, true);
    }

    public initIntro(): void {
        AmbientBackground.changeAmbientBackground("fs", 0);
        let isInPortrait = Scaling.isPortrait();
        this._background.goToCase("NORMAL");
        if (this.ReelFrame != null) {
            this.updateCounterValue(this.ReelFrame, GameManager.freespinsResponse.freeSpins.remainingCount.toString());
        }

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);

        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);
        this.visible = true;
        this.retrigger();

        if (BaseView.FsMessageBox) {
            this.addChild(BaseView.FsMessageBox);
        }
        //this._branchesFs.goToCase("INIT");
        this.setMultiplier();

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSWait");

            BaseView.FsMessageBox.goToCase("FS_END_SHOW");
            //if (isInPortrait)
            if (this._groupTweensFs) {
                this._groupTweensFs.goToCase(GroupTweens.CaseFreespinsToBase);
            }
            if (window["CHANNEL"] === "mobile") {
                this._background.goToCase("HIDE_MOON");
                // if(this._groupTweensFs) {
                //     this._groupTweensFs.goToCase(GroupTweens.CaseFreespinsToBase);
                // }
            }

            if (this._bgParticles) {
                this._bgParticles.goToCase("HIDE");
            }
            //this._background.goToCase('OUTRO');

            const fsCounter = <ImageTextCounterElement>BaseView.FsMessageBox.getChildElementByName("TotalWinCount");
            if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                ImageTextCounterElement.Round = true;
                fsCounter.start(
                    0,
                    parseInt(
                        NumberUtils.devide(GameManager.freespinsResponse.totalWin, BetManager.CoinSize).toString(),
                    ),
                    0,
                );
            } else {
                ImageTextCounterElement.Round = false;
                fsCounter.start(0, GameManager.freespinsResponse.totalWin, 0);
            }
        } else {
            if (this._bgParticles) {
                this._bgParticles.goToCase("START");
                this._bgParticles.goToCase("SHOW");
            }

            PlayList.loop("SND_FSLoop");
        }
    }

    public intro(long: boolean = false): void {
        let isInPortrait = Scaling.isPortrait();
        console.log("FS INTRO");
        if (BaseView.FsMessageBox) {
            this.addChild(BaseView.FsMessageBox);
        }

        //this._branchesFs.goToCase("INIT");

        if (this._bgParticles) {
            this._bgParticles.goToCase("SHOW");
        }

        this.alpha = 1;
        this.visible = true;

        this.setMultiplier();
        if (this.ReelFrame != null) {
            this.updateCounterValue(this.ReelFrame, GameManager.freespinsResponse.freeSpins.remainingCount.toString());
        }
        //if (isInPortrait)
        if (window["CHANNEL"] === "mobile") {
            // if(this._groupTweensFs)
            // {
            //     this._groupTweensFs.goToCase(GroupTweens.CaseBaseToFreespins);
            // }
            this._background.goToCase("SHOW_MOON_DELAYED");
        }
        if (this._groupTweensFs) {
            this._groupTweensFs.goToCase(GroupTweens.CaseBaseToFreespins);
        }

        this.resetReels();
        this._introDelay.start(30);
    }

    public outro(): void {
        this.visible = true;
        let isPortrait = Scaling.isPortrait();
        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_FSWait");
        PlayList.play("SND_FSTransOut");

        this.resetReels();
        AmbientBackground.changeAmbientBackground("base", 60);

        if (BaseView.FsMessageBox) {
            BaseView.FsMessageBox.goToCase("FS_END_HIDE");
        }

        // BaseView.Background.goToCase("TO_NORMAL");
        // if (this._fsMessageEnd != null && !this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageEnd.classList.add(HtmlController.DisabledClass);
        // }
        // if (this._fsMessageEndNoWin != null && !this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageEndNoWin.classList.add(HtmlController.DisabledClass);
        // }
        this._outroDelay.start(40);
    }

    public disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    public enable(): void {
        if (this._bgParticles) {
            this._bgParticles.goToCase("START");
        }
        let isPortrait = Scaling.isPortrait();
        PlayList.setVolume("SND_BaseLoop", 0);
        if (ModuleManager.freespinsEnabled()) {
            PlayList.loop("SND_FSWait");
        }

        BaseView.FsMessageBox.goToCase("FS_START_SHOW");
        //if (isPortrait)
        if (window["CHANNEL"] === "mobile") {
            // BaseView.GroupTweens.goToCase(GroupTweens.CaseFreespinsMessageStart);
            BaseView.Background.goToCase("HIDE_MOON");
        }
        BaseView.GroupTweens.goToCase(GroupTweens.CaseFreespinsMessageStart);

        // if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
        // }
    }

    private onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    private machineStopped(): void {
        if (this._winAnimator.isWild) {
            this._machineStoppedDelay.stop();
            this._machineStoppedDelay.start(45);
        } else {
            this.machineStoppedDelayed();
        }
    }

    private machineStoppedDelayed(): void {
        this._controller.machineStopped();
        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSLoop");
        }
        let isInPortrait = Scaling.isPortrait();
        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                PlayList.stop("SND_FSLoop");
                PlayList.loop("SND_FSWait");

                BaseView.FsMessageBox.goToCase("FS_END_SHOW");
                //if (isInPortrait)
                if (window["CHANNEL"] === "mobile") {
                    // if(this._groupTweensFs) {
                    //     this._groupTweensFs.goToCase(GroupTweens.CaseFreespinsToBase);
                    // }
                    this._background.goToCase("HIDE_MOON");
                }
                if (this._groupTweensFs) {
                    this._groupTweensFs.goToCase(GroupTweens.CaseFreespinsToBase);
                }
                if (this._bgParticles) {
                    this._bgParticles.goToCase("HIDE");
                }
                //this._background.goToCase('OUTRO');

                const fsCounter = <ImageTextCounterElement>BaseView.FsMessageBox.getChildElementByName("TotalWinCount");
                if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                    ImageTextCounterElement.Round = true;
                    fsCounter.start(
                        0,
                        parseInt(
                            NumberUtils.devide(GameManager.freespinsResponse.totalWin, BetManager.CoinSize).toString(),
                        ),
                        0,
                    );
                } else {
                    ImageTextCounterElement.Round = false;
                    fsCounter.start(0, GameManager.freespinsResponse.totalWin, 0);
                }
            }
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    private finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    private finishWinAnimator(): void {
        this._controller.allWinsFinished();
        let isInPortrait = Scaling.isPortrait();
        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSWait");

            BaseView.FsMessageBox.goToCase("FS_END_SHOW");
            //if (isInPortrait)
            if (window["CHANNEL"] === "mobile") {
                // if(this._groupTweensFs) {
                //     this._groupTweensFs.goToCase(GroupTweens.CaseFreespinsToBase);
                // }
                this._background.goToCase("HIDE_MOON");
            }
            if (this._groupTweensFs) {
                this._groupTweensFs.goToCase(GroupTweens.CaseFreespinsToBase);
            }
            if (this._bgParticles) {
                this._bgParticles.goToCase("HIDE");
            }
            //this._background.goToCase('OUTRO');

            const fsCounter = <ImageTextCounterElement>BaseView.FsMessageBox.getChildElementByName("TotalWinCount");
            if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
                ImageTextCounterElement.Round = true;
                fsCounter.start(
                    0,
                    parseInt(
                        NumberUtils.devide(GameManager.freespinsResponse.totalWin, BetManager.CoinSize).toString(),
                    ),
                    0,
                );
            } else {
                ImageTextCounterElement.Round = false;
                fsCounter.start(0, GameManager.freespinsResponse.totalWin, 0);
            }
        } else {
            if (this._bgParticles) {
                this._bgParticles.goToCase("SHOW");
            }
            PlayList.loop("SND_FSLoop");
        }
        this.retrigger();
    }

    private introFinished(): void {
        PlayList.loop("SND_FSLoop", 15);
        if (this.ReelFrame != null) {
            this.ReelFrame.goToCase("START_FS");
            this._multiplierDelay.start(30);
        }
        this._controller.introFinished();
    }

    private outroFinished(): void {
        this.visible = false;

        if (this._bgParticles) {
            this._bgParticles.goToCase("STOP");
        }

        this._winAnimator.resetTimer();
        this._controller.outroFinished();
        this._winAnimator.resetOverlay();
    }

    private retrigger(): void {
        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                    }
                }
            }
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }

    private resetReels(): void {
        for (let i: number = 0; i < 5; i++) {
            if (this.childs["Reel" + i] != null) {
                this.childs["Reel" + i].visible = true;
            }
            if (this.childs["ReelWin" + i] != null) {
                this.childs["ReelWin" + i].visible = false;
            }
        }
    }

    private updateCounterValue(counter: SwitchElement, value: string, elementName: string = "Amount"): void {
        if (counter != null) {
            let n1 = counter.getChildElementByName(elementName);
            if (n1) {
                this.updateValue(<ImageTextCounterElement>n1, value);
            }
        }
    }

    private updateValue(elem: ImageTextCounterElement, value: string): void {
        elem.bitmapText.text = value;
        elem.realign();
    }

    private setMultiplier(): void {
        FreespinsView.Multiplier = GameManager.freespinsResponse.freeSpins.multiplier;
        this.ReelFrame.goToCase("X" + FreespinsView.Multiplier);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/